// extracted by mini-css-extract-plugin
export default {"navContainer":"Navbar_navContainer__dqGNd","navImage":"Navbar_navImage__6zL+o"};